export default "__VITE_ASSET__C_qFodh6__"